import { useEffect, useState } from 'react';
import { useUserAgent } from './useUserAgent';

export const useIsMobile = () => {
    const { device } = useUserAgent();
    const [isMobile, setIsMobile] = useState(false);
    const [isApple, setIsApple] = useState(false);

    useEffect(() => {
        setIsMobile(device.type === 'mobile' || device.type === 'tablet');
        setIsApple(device.vendor === 'Apple');
    }, [device]);
    return { isMobile, isApple };
};
